import { useEffect, useMemo, useState } from 'react';
import {
  getLang,
  setLang,
  subscribeLang,
  getDashboardMessages,
  getPagesMessages,
  getAdminMessages,
  formatMessage,
  AppLang,
  APP_LANGS,
  LANG_LABELS,
  LANG_SHORT,
  LANG_FLAGS,
} from './index';
import type { DashboardMessages } from './locales/dashboard';
import type { PagesMessages } from './locales/pages';
import type { AdminMessages } from './locales/admin';

export function useI18n(): {
  lang: AppLang;
  setLang: (lang: AppLang) => void;
  dashboard: DashboardMessages;
  pages: PagesMessages;
  admin: AdminMessages;
  formatMessage: typeof formatMessage;
  langs: AppLang[];
  langLabels: typeof LANG_LABELS;
  langShort: typeof LANG_SHORT;
  langFlags: typeof LANG_FLAGS;
} {
  const [lang, setLangState] = useState<AppLang>(() => getLang());

  useEffect(() => {
    return subscribeLang((next) => setLangState(next));
  }, []);

  const dashboard = useMemo(() => getDashboardMessages(), [lang]);
  const pages = useMemo(() => getPagesMessages(), [lang]);
  const admin = useMemo(() => getAdminMessages(), [lang]);

  return {
    lang,
    setLang,
    dashboard,
    pages,
    admin,
    formatMessage,
    langs: APP_LANGS,
    langLabels: LANG_LABELS,
    langShort: LANG_SHORT,
    langFlags: LANG_FLAGS,
  };
}
